import { PillSelectProps } from '@procore/core-react/dist/_typedoc/PillSelect/PillSelect.types.json';
import * as React from 'react';
export default {
  PillSelectProps,
  React
};